module.exports = __webpack_public_path__ + "media/images/file-513ef45da688f16f018e068f93287ec4.svg";